import { t } from '../i18n'
import { track } from './analytics'
import { storyUrl } from './article'

/* Share a story's Instapres link (never the portal's link, spec 9.9): the
   system share sheet where there is one, else copy it. `notify` shows a toast. */
export async function shareStory(story, notify, from = 'card') {
  const url = storyUrl(story.id)
  track('share', { from })
  if (navigator.share) {
    try {
      await navigator.share({ title: story.title, url })
      return
    } catch (e) {
      if (e && e.name === 'AbortError') return // the user closed the sheet
    }
  }
  try {
    await navigator.clipboard.writeText(url)
    notify(t('share.copied'))
  } catch (e) {
    notify(t('share.failed'))
  }
}
